import { useState } from "react";
import { hotRank, type PostItem } from "@/mocks/gossipData";

const rankColors = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

function renderHeatBar(item: PostItem) {
  return (
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
      <div className="h-full rounded-full bg-primary-500" style={{ width: `${item.heat}%` }}></div>
    </div>
  );
}

export default function Trending() {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  return (
    <section id="trending" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-fire-fill"></i>
              每日更新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">今日热榜</h2>
            <p className="mt-2 text-sm text-foreground-600">按实时讨论热度排序的当日精选，先看这份不迷路。</p>
          </div>
          <div className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-time-line"></i>
            更新于今日 12:00
          </div>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hotRank.map((item, idx) => (
            <li
              key={item.id}
              className="group rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-all hover:border-accent-300 hover:bg-background-100/50"
            >
              <div className="flex items-start gap-4">
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-bold text-background-50 ${
                    rankColors[idx % 3]
                  }`}
                >
                  {idx + 1}
                </div>
                <div className="min-w-0 flex-1">
                  <button
                    type="button"
                    onClick={() => setExpandedId(expandedId === item.id ? null : item.id)}
                    className="w-full text-left"
                    aria-expanded={expandedId === item.id}
                  >
                    <h3 className="font-medium leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {item.title}
                    </h3>
                  </button>
                  <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-200/70 px-2.5 py-0.5 text-foreground-600">
                      {item.category}
                    </span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-heart-3-fill text-primary-400"></i>
                      {item.likes.toLocaleString()}
                    </span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i>
                      {item.comments.toLocaleString()}
                    </span>
                    <span className="hidden sm:inline-flex items-center gap-1 whitespace-nowrap text-accent-600">
                      <i className="ri-flashlight-fill"></i>
                      {item.heat}%
                    </span>
                  </div>
                  <div className="mt-3 flex items-center gap-3">
                    {renderHeatBar(item)}
                    <span className="whitespace-nowrap text-[11px] text-foreground-500">{item.heat}°</span>
                  </div>
                </div>
              </div>

              {expandedId === item.id && (
                <div className="mt-4 rounded-xl bg-background-100/60 p-4">
                  <p className="text-sm leading-relaxed text-foreground-700">{item.excerpt}</p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="whitespace-nowrap rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-700">
                      {item.tag}
                    </span>
                    <a
                      href="#subscribe"
                      className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 hover:text-primary-700"
                    >
                      进合集围观
                      <i className="ri-arrow-right-up-line"></i>
                    </a>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}